import React, { useState } from 'react'
import './style.css'
import Button from '../CtaButton'
import ActionButton from '../ActionButton'
import { toast, ToastContainer } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { GoHighLevelAPI, SendEmailAPI } from '../../redux/slices/SendEmail'
import { useLocation } from 'react-router-dom'

const ServicesBannerForm = () => {

    const location = useLocation();
    const pageSlug = location.pathname

    const [serviceFormData, setServiceFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const dispatch = useDispatch();

    // helper to check form validity
    const isFormEmpty = !serviceFormData.name.trim() || !serviceFormData.email.trim() || !serviceFormData.message.trim();


    const [isLoading, setIsLoading] = useState(false)

    const scriptURL = process.env.REACT_APP_GSHEET_URL;

    const handleChange = (e) => {
        const { id, value } = e.target;
        setServiceFormData(prevData => ({
            ...prevData,
            [id]: value
        }));
    };

    const sheet = "ServicesPageData"

    const state = {
        Name: serviceFormData.name,
        Email: serviceFormData.email,
        ProjectDetails: serviceFormData.message,
        SheetName: sheet
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(state, "here is the for sheet data");
        setIsLoading(true);

        const urlEncodedData = new URLSearchParams(state).toString();

        // console.log(process.env.REACT_APP_GHL_API_KEY, "api key");
        // return

        try {
            await fetch(scriptURL, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: urlEncodedData,
            });

            // console.log('Successfully submitted to Google Sheet.');
            toast.success("Submission complete. Thank you.");
            setServiceFormData({ name: '', email: '', message: '' });
            const res = dispatch(SendEmailAPI(serviceFormData))

            const goHighLevelApiObjectData = {
                firstName: serviceFormData?.name,
                email: serviceFormData?.email,
                // additional_notes: serviceFormData.message,
                tags: [pageSlug, "Filled website form",],
                "customField": {
                    "1U1sbPiPhcCOhyONNCDE": serviceFormData.message // additional_info
                }
            }
            const serviceFormObject = dispatch(GoHighLevelAPI(goHighLevelApiObjectData))

            // if (res.type === "SendEmailAPI/fulfilled") {
            //     toast.success(res?.payload?.message);
            // } else if (res.type === "SendEmailAPI/rejected") {
            //     toast.success(res.payload.errors);
            // } else {
            //     toast.error("Sorry, something went wrong!");
            // }
            console.log(serviceFormData, "kkkkkkkkkkkk");
        } catch (error) {
            toast.error('Submission failed:', error);
            alert('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <ToastContainer hideProgressBar={true} />
            <div className="services-banner-form service-banner-form-main">
                <h3>Get expert help for your projects.</h3>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="form-label">Your name</label>
                        <input
                            type="text"
                            className="form-control banner-form-input"
                            id="name"
                            placeholder="Full name"
                            value={serviceFormData.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="email" className="form-label">Your email</label>
                        <input
                            type="email"
                            className="form-control banner-form-input"
                            id="email"
                            placeholder="name@company.com"
                            value={serviceFormData.email}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="message" className="form-label">What we can do for you?</label>
                        <textarea
                            className="form-control banner-form-input"
                            id="message"
                            rows={3}
                            placeholder="Tell us about your needs."
                            value={serviceFormData.message}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mt-5">
                        <ActionButton text={isLoading ? 'Submitting...' : 'Jump-start Your Project'}
                            disabled={isLoading || isFormEmpty}
                            type="submit"
                            styles={{ width: '100%' }} />
                    </div>
                </form>
            </div>


            <div className='banner-mobile-model'>
                <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="services-banner-form service-banner-form-model">
                                    <h3>Get expert help for your projects.</h3>
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-4">
                                            <label htmlFor="name" className="form-label">Your name</label>
                                            <input
                                                type="text"
                                                className="form-control banner-form-input"
                                                id="name"
                                                placeholder="Full name"
                                                value={serviceFormData.name}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <label htmlFor="email" className="form-label">Your email</label>
                                            <input
                                                type="email"
                                                className="form-control banner-form-input"
                                                id="email"
                                                placeholder="name@company.com"
                                                value={serviceFormData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <label htmlFor="message" className="form-label">What we can do for you?</label>
                                            <textarea
                                                className="form-control banner-form-input"
                                                id="message"
                                                rows={3}
                                                placeholder="Tell us about your needs."
                                                value={serviceFormData.message}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="mt-4">
                                            <ActionButton text={isLoading ? 'Submitting...' : 'Jump-start Your Project'}
                                                disabled={isLoading || isFormEmpty}
                                                type="submit"
                                                styles={{ width: '100%' }} />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <span className='banner-form-model-button' data-bs-target="#exampleModalToggle" data-bs-toggle="modal">
                    <Button text='Jump-start Your Project' link='#' />
                </span>
            </div>
        </>
    )
}

export default ServicesBannerForm